/* global pushToDataLayer */

// To capture Add This sharing on Google Analytics
$(window).load(function addThis() {
    var addthisMainTag = $('div.addthis_sharing_toolbox');

    if (addthisMainTag.length > 0) {
        $(addthisMainTag).find('a').click(function() {
            var label = $(this).find('span').first().attr('title');
            pushToDataLayer('social-int', '', '', 'share', label);
        });
    }
});
